<template>
    <div class="intro">
        <h1 class="title">WHY ME?</h1>
        <p>
            Because Im Good at Finding solutions I read stack overflow
            solutions. I am also up to date to the latest tech-trends and I
            never stop studying and making sure that I am always making progress
            to improve my skill that I can utilize for making a project
        </p>
    </div>
    <div class="content">
        <h1 class="title">here are my skills</h1>
        <div class="cards">
            <div class="cards">
                <div class="card" @click="openDrawer(1)">
                    <div class="head-group">
                        <img src="@/assets/images/db.webp" alt="" />
                        <h2>BACK-END<br />DEVELOPER</h2>
                    </div>

                    <p>
                        What is back-end development? Back-end development means
                        working on server-side software, which focuses on
                        everything you can't see on a website. Back-end
                        developers ensure the website performs correctly,
                        focusing on databases, back-end logic, application
                        programming interface (APIs), architecture, and servers.
                    </p>
                    <p>TECHNOLOGY USED</p>
                </div>
                <div class="card" @click="openDrawer(2)">
                    <div class="head-group">
                        <img src="@/assets/images/windows2.png" alt="" />
                        <h2>
                            UI/UX<br />
                            DESIGNER
                        </h2>
                    </div>

                    <p>
                        User interface design or user interface engineering is
                        the design of user interfaces for machines and software,
                        such as computers, home appliances, mobile devices, and
                        other electronic devices, with the focus on maximizing
                        usability and the user experience.
                    </p>
                    <p>TECHNOLOGY USED</p>
                </div>
                <div class="card" @click="openDrawer(3)">
                    <div class="head-group">
                        <img src="@/assets/images/code.webp" alt="" />
                        <h2>FRONT-END <br />DEVELOPER</h2>
                    </div>

                    <p>
                        Front-end web development is the development of the
                        graphical user interface of a website, through the use
                        of HTML, CSS, JavaScript, and various frameworks /
                        libraries of them, so that users can view and interact
                        with that website.
                    </p>
                    <p>TECHNOLOGY USED</p>
                </div>
            </div>
        </div>
    </div>
    <transition name="bounce">
        <div class="drawer" v-if="showDrawer">
            <div class="inner-drawer">
                <swiper :space-between="20">
                    <swiper-slide
                        v-for="(slide, index) in activeSkills"
                        :key="index"
                    >
                        <div class="icon">
                            <img :src="slide.img" alt="" />
                        </div>
                        <div class="slide-title">{{ slide.title }}</div>
                        <div class="desc">{{ slide.body }}</div>
                    </swiper-slide>
                </swiper>
                <div class="close" @click="close">
                    <img src="@/assets/mobile/close.png" alt="" />
                </div>
            </div>
        </div>
    </transition>
</template>
<script>
import { ref } from "vue";
import { Swiper, SwiperSlide, Navigation } from "swiper/vue";

export default {
    components: {
        Swiper,
        SwiperSlide,
    },
    setup() {
        const showDrawer = ref(false);
        const activeSkills = ref([]);
        const openDrawer = (type) => {
            showDrawer.value = true;
            if (type == 3) {
                activeSkills.value = front_end.value;
            }
            if (type == 2) {
                activeSkills.value = ui_ux.value;
            }
            if (type == 1) {
                activeSkills.value = back_end.value;
            }

            console.log(activeSkills.value);
        };
        const front_end = ref([
            {
                title: "CSS",
                body: "CSS is a style sheet language used for formatting content in HTML webpages. CSS style sheets can define the appearance and formatting of text, tables, and other elements separately from the content itself. Styles may be found within a webpage's HTML file or in a separate document referenced by multiple webpages.",
                img: require("@/assets/images/skill_slider/css_logo.webp"),
                top: "-140px",
            },
            {
                title: "HTML",
                body: "HTML, or HyperText Markup Language, is a standard markup language used for creating web pages and applications. It provides the structure and content of web content, while other technologies like CSS and JavaScript are often used to add styling and dynamic functionality.",
                img: require("@/assets/images/skill_slider/html_logo.webp"),
                top: "-140px",
            },

            {
                title: "VUE",
                body: "Vue is a JavaScript framework for building user interfaces. It builds on top of standard HTML, CSS, and JavaScript and provides a declarative and component-based programming model that helps you efficiently develop user interfaces, be they simple or complex.",
                img: require("@/assets/images/skill_slider/vue_logo.webp"),
                top: "-60px",
            },
            {
                title: "JS",
                body: "JavaScript is a dynamic programming language that's used for web development, in web applications, for game development, and lots more. It allows you to implement dynamic features on web pages that cannot be done with only HTML and CSS.",
                img: require("@/assets/images/skill_slider/js_logo.webp"),
                top: "-94px",
            },
        ]);
        const back_end = ref([
            {
                title: "MySql ",
                body: "A database is a structured collection of data. It may be anything from a simple shopping list to a picture gallery or the vast amounts of information in a corporate network. To add, access, and process data stored in a computer database, you need a database management system such as MySQL Server. ",
                img: require("@/assets/images/skill_slider/sql_logo.webp"),
                top: "-94px",
            },
            {
                title: "Laravel ",
                body: "Laravel is a web application framework with expressive, elegant syntax. We’ve already laid the foundation — freeing you to create without sweating the small things.",
                img: require("@/assets/images/skill_slider/larvel_logo.webp"),
                top: "-94px",
            },
        ]);
        const ui_ux = ref([
            {
                title: "Photoshop",
                body: "Adobe Photoshop is a raster graphics editor developed and published by Adobe Inc. for Windows and macOS. It was originally created in 1987 by Thomas and John Knoll. Since then, the software has become the most used tool for professional digital art, especially in raster graphics editing",
                img: require("@/assets/images/skill_slider/ps_logo.webp"),
                top: "-94px",
            },
            {
                title: "Figma ",
                body: "Figma is a collaborative web application for interface design, with additional offline features enabled by desktop applications for macOS and Windows.",
                img: require("@/assets/images/skill_slider/figma_logo.webp"),
                top: "-94px",
            },
        ]);
        const close = () => {
            showDrawer.value = false;
            activeSkills.value = [];
        };
        return {
            showDrawer,
            openDrawer,
            back_end,
            ui_ux,
            front_end,
            activeSkills,
            close,
            modules: [Navigation],
        };
    },
};
</script>
<style lang="scss" scoped>
.title {
    text-align: left;
    color: #ecb365;
}
.intro {
    padding: 0 8vw;
    p {
        margin-top: 2vh;
        color: #fff;
        font-weight: lighter;
    }
}
.swiper {
    padding: 3vh 3vw 6vh 3vw;
    transform: translate(6vw, 0);
}
.swiper-slide {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;

    img {
        width: 24vw;
    }
    .slide-title {
        font-size: 30px;
        font-weight: bolder;
    }
}
.drawer {
    position: fixed;
    bottom: 0;
    width: 100vw;
    height: 100%;
    z-index: 9999;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    background: rgba(0, 0, 0, 0.5);

    .inner-drawer {
        width: 100vw;
        display: flex;
        justify-content: center;
        align-items: flex-start;
        background-color: #eacaa0;
        border-top-left-radius: 30vw;
        border-top-right-radius: 30vw;
        border-top: 4px solid #f16529;
        position: absolute;
        bottom: 0;
        .close {
            transform: translate(0vw, -5vw);
        }
    }
}
.content {
    padding: 0 8vw;
    margin-top: 4vh;
    background: url("@/assets/images/Vector.webp") no-repeat;
    background-position: center;
    .cards {
        display: flex;
        justify-content: space-between;
        flex-direction: column;
        z-index: 999;
        gap: 4vh;
        margin: 2vh 0;
        .card {
            padding: 5vw;
            width: 75vw;
            box-shadow: 0 0 30px #000;
            border-radius: 20px;
            border-bottom: 10px solid #ecb365;
            background: #041c32;
            position: relative;
            .head-group {
                display: flex;
                justify-content: flex-start;
                align-items: center;
                gap: 5vw;
            }
            &:first-child,
            &:last-child {
                background: #064663;
            }
            h2 {
                font-size: 20px;
                color: #ecb365;
                margin: 30px 0 30px;
            }
            p {
                color: #fff;
                font-weight: lighter;
                font-size: 13px;
                &:last-child {
                    color: #ecb365;
                    font-weight: bolder;
                    margin-top: 80px;
                    font-size: 15px;
                    cursor: pointer;
                }
            }
        }
    }
}
</style>
